// extracted by mini-css-extract-plugin
export default {"form":"SubscribeForm_form__ZzUxD","formGroup":"SubscribeForm_formGroup__8XeQ2","logo":"SubscribeForm_logo__VcxyP"};